export default "__VITE_ASSET__BbLI6wCp__"